import React, {useEffect, useState} from 'react';
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import {selAgencyForm, initAgencyForm, selProvinces, onAgencyFormChange} from "../../../stores/agency/agencySlice";
import {createAgency, editAgency, getAgencyById, getProvinces} from "../../../stores/agency/agencyThunks";
import useValidation from "../../../validation/useValidation";
import {agencyValidations, FormAgencyInit} from "../../../stores/agency/agencyModel";
import {onProductFormAttributeChange} from "../../../stores/product/slice";

export default function Agency() {

    const agency = useSelector(selAgencyForm);
    const provinces = useSelector(selProvinces);
    const [test, setTest] = useState('');
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();

    const {errors, checkFiled, checkValidation} = useValidation({
        data: agencyValidations,
        key: 'agencyForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onAgencyFormChange({name, value}))
    }

    function backToAgencies() {
        history.push('/agencies');
    }

    const redirectToAgencies =()=> history.push("/agencies")

    function addAgency(){
        const data = {
            province_id: agency.province?.id,
            address: agency.address,
            name: agency.name,
            postal_code: agency.postal_code,
            tel: agency.tel
        }
        dispatch(createAgency(data, redirectToAgencies))
    }

    function putAgency(){
        const data = {
            province_id: agency.province?.id,
            address: agency.address,
            name: agency.name,
            postal_code: agency.postal_code,
            tel: agency.tel
        }
        dispatch(editAgency(id, data, redirectToAgencies))
    }



    useEffect(() => {
        dispatch(getProvinces());
        id ?
            dispatch(getAgencyById({id}))
            :
            dispatch(initAgencyForm(FormAgencyInit))
        return ()=>{
            dispatch(initAgencyForm(FormAgencyInit))
        }
    }, [id])


    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن نمایندگی"
                backBtnTitle="بازگشت"
                backBtnAction={backToAgencies}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'عنوان نمایندگی'}
                                        variant="outlined"
                                        name={'name'}
                                        value={agency.name}
                                        error={errors.name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Autocomplete
                                        className={`w-100`}
                                        value={agency?.province}
                                        options={provinces}
                                        getOptionLabel={(option) => option.name ? option.name : ''}
                                        onChange={(event, value) => {
                                            checkFiled('province', value);
                                            dispatch(onAgencyFormChange({name: 'province', value: value}))
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       error={errors?.province}
                                                       variant="outlined"
                                                       className={`w-100`}
                                                       label="استان"/>
                                        )}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'آدرس'}
                                        variant="outlined"
                                        name={'address'}
                                        value={agency.address}
                                        error={errors.address}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'کد پستی'}
                                        variant="outlined"
                                        name={'postal_code'}
                                        value={agency.postal_code}
                                        error={errors.postal_code}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'تلفن'}
                                        variant="outlined"
                                        name={'tel'}
                                        value={agency.tel}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putAgency : addAgency }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            ایجاد
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
